import _isEmpty from 'lodash/isEmpty';
import { Component } from 'react';
import { gql } from '@apollo/client';
import { withApollo } from '@apollo/react-hoc';
import logger from '$lib/logger';
import history from '$src/lib/history';
import storage from '$src/lib/storage';

const TRACK_ACTIVITY = gql`
  mutation trackActivity($input: TrackActivityInput!) {
    trackActivity(input: $input) {
      _empty
    }
  }
`;

const IDLE_TIMEOUT = 1000 * 45;
const UPLOAD_INTERVAL = 1000 * 60 * 5;

let currentPathname;
let startTime;
let activityTimeout;

let addActivityListeners;
let removeActivityListeners;
let setActivityTimeout;

(() => {
  const nowMs = +new Date();
  startTime = nowMs;
  currentPathname = history.location.pathname;
})();

const recordEntry = ({ nextPathname }) => {
  clearTimeout(activityTimeout);

  const nowMs = +new Date();
  const ms = nowMs - startTime;
  const entry = {
    path: currentPathname,
    ms,
  };

  if (nextPathname) {
    currentPathname = nextPathname;
  }

  startTime = nowMs;

  const entries = storage.activityEntries.get();
  const nextEntries = entries.concat(entry);
  storage.activityEntries.set(nextEntries);
};

const resetTimer = () => {
  const nowMs = +new Date();
  startTime = nowMs;
};

const windowOnFocus = () => {
  resetTimer();
  setActivityTimeout();
};

const windowOnBlur = () => {
  recordEntry({});
  clearTimeout(activityTimeout);
};

window.addEventListener('focus', windowOnFocus);
window.addEventListener('blur', windowOnBlur);

const idleDetected = () => {
  recordEntry({});
  addActivityListeners();
};

setActivityTimeout = () => {
  activityTimeout = setTimeout(idleDetected, IDLE_TIMEOUT);
};

const activityDetected = () => {
  removeActivityListeners();
  resetTimer();
  setActivityTimeout();
};

const activityEvents = [
  'mousemove',
  'mousedown',
  'touchstart',
  'click',
  'scroll',
  'keypress',
];

addActivityListeners = () => {
  activityEvents.forEach((event) =>
    document.addEventListener(event, activityDetected, true)
  );
};

removeActivityListeners = () => {
  activityEvents.forEach((event) =>
    document.removeEventListener(event, activityDetected, true)
  );
};

history.listen((location, _action) => {
  recordEntry({ nextPathname: location.pathname });
  clearTimeout(activityTimeout);
  setActivityTimeout();
});

class Track extends Component {
  uploadActivityEntries = async () => {
    const { client, currentUser } = this.props;

    if (!currentUser) {
      return;
    }

    const entries = storage.activityEntries.get();
    if (_isEmpty(entries)) {
      return;
    }

    storage.activityEntries.set([]);

    try {
      await client.mutate({
        mutation: TRACK_ACTIVITY,
        variables: {
          input: {
            entries,
          },
        },
      });
    } catch (e) {
      logger.error(e);
      const newEntries = storage.activityEntries.get();
      storage.activityEntries.set(entries.concat(newEntries));
    }
  };

  componentDidMount() {
    // eslint-disable-line class-methods-use-this
    const nowMs = +new Date();
    startTime = nowMs;
    setActivityTimeout();

    this.uploadActivityEntries();
    this.uploadInterval = setInterval(this.uploadActivityEntries, UPLOAD_INTERVAL);
  }

  componentWillUnmount() {
    clearInterval(this.uploadInterval);
  }

  render() {
    return null;
  }
}

export default withApollo(Track);
